import React, { CSSProperties, useId, useMemo } from "react";
import classNames from "classnames";
import { artworkForInstance } from "@/features/HomepageMascot/artwork";
import cls from "./visual.module.scss";

interface Props {
  className?: string;
  active?: boolean;
  gaze?: { x: number; y: number };
}

export function FireflyVisual({ className, active = true, gaze }: Props) {
  const id = useId();
  // Reuse the saved mascot artwork, not its guide runtime. Each miniature
  // needs its own SVG clip IDs, including page flights and editor previews.
  const artwork = useMemo(
    () => ({
      __html: artworkForInstance(
        `pet-firefly-${id.replace(/[^a-z0-9_-]/gi, "")}`
      ),
    }),
    [id]
  );

  return (
    <span
      aria-hidden="true"
      className={classNames(cls.visual, className)}
      data-firefly-visual
      data-active={active}
      style={
        {
          "--firefly-look-x": `${gaze?.x ?? 0}px`,
          "--firefly-look-y": `${gaze?.y ?? 0}px`,
        } as CSSProperties
      }
    >
      <span className={cls.character} dangerouslySetInnerHTML={artwork} />
    </span>
  );
}
